import { getSrcs } from '@helpers/image';
import { ComponentTheme } from '@helpers/themeEnum';
import SvgPathwayFallback from '@img/pathway-fallback.svg';
import { FakeButton } from '@stories/Components/Buttons/GeneralButton/Button';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import { FeaturedBlogCardStyles as S } from './FeaturedBlogCard.styles';
import { formatDate, formatDateISO } from '@helpers/date';
import { getSvgFromSystem, SystemIcon } from '@helpers/systemIcons';
const FeaturedBlogCard = ({ tag, cta, image, ratio = 1.35, publishDate, readTime, author, summary, theme = ComponentTheme.Blue, title, translations, }) => {
    const srcs = image ? getSrcs(image, 862, 278, 4, ratio, image.focalPoint) : undefined;
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.Container, { href: cta.url, target: cta.target ?? '_self', "data-square": ratio === 1 },
            React.createElement(S.Inner, null,
                React.createElement(S.ContentArea, null,
                    React.createElement(S.ContentInner, null,
                        React.createElement(S.ContentTop, null,
                            tag && React.createElement(S.Caption, null, tag),
                            React.createElement(S.Date, { dateTime: formatDateISO(publishDate) }, formatDate(publishDate, 'dd/MM/yyyy'))),
                        React.createElement(S.Title, null, title),
                        summary && React.createElement(S.Intro, null, summary),
                        author && React.createElement(S.Author, null,
                            translations['translations.blog.authorintro'],
                            " ",
                            author),
                        React.createElement(S.ContentBottom, null,
                            React.createElement(S.FakeButton, null,
                                React.createElement(FakeButton, { styleType: "underline", backgroundPlacement: "light", branding: theme == ComponentTheme.White ? ComponentTheme.Black : theme, buttonSize: 'large', title: cta.text ?? 'Read More' })),
                            readTime && React.createElement(S.ReadTime, null,
                                getSvgFromSystem(SystemIcon.Clock),
                                " ",
                                React.createElement("span", null,
                                    readTime,
                                    " ",
                                    translations && translations['translations.blog.readtime']))))),
                React.createElement(S.MediaHolder, null, image && image.src && srcs ? (React.createElement(S.Image, { alt: image.altText ?? '', loading: "lazy", role: image.altText ? undefined : 'presentation', src: srcs[0].split(' ')[0], srcSet: srcs.join(',') })) : (React.createElement(SvgPathwayFallback, null)))))));
};
export default FeaturedBlogCard;
